export default __webpack_public_path__ + "static/media/7.ab3ca03f.jpg";